import type { Resource } from "@medplum/fhirtypes";
import type { SyncRecords } from "@repo/api";
import type { FhirCollectionUtils } from "../fhir/base";
import type { DataStoreClient } from "./client";

export function applySync(client: DataStoreClient, sync: SyncRecords): void {
  for (const name of client.getCollectionNames()) {
    const collection = client.getCollection<Resource, string, FhirCollectionUtils>(name);
    if (!collection.id.startsWith("fhir:")) continue;
    const resourceType = collection.id.split(":")[1];
    for (const resource of sync.written) {
      if (resource.resourceType === resourceType) collection.utils.updateRecord(resource);
    }
    for (const resource of sync.deleted) {
      if (resource.resourceType === resourceType) collection.utils.deleteRecord(resource);
    }
  }
}
